import styles from './nav-button.module.scss';
import { FC } from 'react';
import { DynamicIcon } from '../../atoms/dynamic-icon/dynamic-icon';
import { WListItemButton } from '../../wrappers/wrapper';
interface NavButtonProps {
  title: string;
  icon: string;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
}

const NavButton: FC<NavButtonProps> = ({ icon, title, isActive, className, onClick }) => {
  const classes = `
  ${styles.navButton} 
  ${isActive && styles.active}
  ${className || ''}`.trim();

  return (
    <WListItemButton className={classes} onClick={onClick}>
      <DynamicIcon iconName={icon} />
      <span className={styles.text}>{title}</span>
    </WListItemButton>
  );
};

export default NavButton;
